import { render } from "./IconCalendar2.vue?vue&type=template&id=15ddd53d"
import script from "./IconCalendar2.vue?vue&type=script&lang=js"
export * from "./IconCalendar2.vue?vue&type=script&lang=js"

import exportComponent from "/home/developer/public_html/user.cureline-crm.cureline.com/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__